import React, { useEffect } from 'react';
import AppHeader from '../AppHeader';
import SelectDropdown from '../SelectDropdown';
import { CircularProgress, Box } from '@mui/material';
import {
  getLaborDropdownOptions,
  getTrendDropdownOptions,
  toTitleCase,
  getStoreChecker,
  getLocationNameWithoutState,
  getLocationStateToken,
} from '../../utils/utils';
import { useLazyQuery } from '@apollo/client';
import { GET_DEFAULT_LOCATION } from '../../graphql/queries';
import ErrorMessage from '../ErrorMessage';
import {
  DATA_FETCH_ERROR,
  ONLOAN_INVALID_STOREID_ERROR,
} from '../../common/constants';
import './styles.scss';
import BottomNavigator from '../BottomNavigator/BottomNavigator';
import { connect, useSelector } from 'react-redux';
import { setCurrentDateMatrix } from '../../actions/actions';
import { LaborTabManager } from '../TabManager';
import PropTypes from 'prop-types';

const filterContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  mt: 1,
};

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    fontSize: '1.6rem',
    fontFamily: 'Franklin Gothic Pro ',
    color: state.isSelected ? '#FFFFFF' : '#353535',
    padding: 7,
  }),
};

const LaborDetails = ({ employeeInfo = {}, currentDateMatrix }) => {
  const [options, setOptions] = React.useState([]);
  const [tab, setTab] = React.useState('');
  const currentActiveTab = useSelector(
    (state) => state.currentActiveTab.currentActiveTab
  );
  useEffect(() => {
    setTab(currentActiveTab);
  }, [tab, currentActiveTab]);

  const [selectedDate, setSelectedDate] = React.useState(null);
  const userEmail = employeeInfo.adUpn;
  const [selectedLocation, setSelectedLocation] = React.useState(
    JSON.parse(sessionStorage.getItem('selectedLocation'))
  );
  let selectedStoreId = localStorage.getItem('storeId');
  const activeStorechecker = getStoreChecker(selectedStoreId);
  const [
    getDefaultLocation,
    { error: locationError = {}, loading: locationLoading },
  ] = useLazyQuery(GET_DEFAULT_LOCATION, {
    onCompleted: (data) => {
      let { salesSummaryV2 } = data;
      if (selectedLocation.locationName === 'NA') {
        setSelectedLocation({
          locationNo: salesSummaryV2?.location?.primaryLocationNumber,
          locationName: salesSummaryV2?.location?.primaryLocationName,
        });
        sessionStorage.setItem(
          'selectedLocation',
          JSON.stringify({
            locationNo: salesSummaryV2?.location?.primaryLocationNumber,
            locationName: salesSummaryV2?.location?.primaryLocationName,
          })
        );
      }
    },
  });

  useEffect(() => {
    let options = [];
    if (tab === 'Labor') {
      options = getLaborDropdownOptions();
    } else {
      options = getTrendDropdownOptions();
    }
    setOptions(options);
    let dropdownVal = '';
    if (localStorage.hasOwnProperty('selectedDate')) {
      if (
        localStorage.getItem('selectedDate') === 'YESTERDAY' ||
        localStorage.getItem('selectedDate') === 'WTD' ||
        localStorage.getItem('selectedDate') === 'LCW'
      ) {
        if (tab === 'Labor') {
          dropdownVal = 'LCW';
        } else {
          dropdownVal = 'MTD';
        }
      } else {
        dropdownVal = localStorage.getItem('selectedDate');
      }
    } else if (tab === 'Labor') {
      dropdownVal = 'LCW';
    } else {
      dropdownVal = 'MTD';
    }
    const defaultValue = options.find((obj) => obj.value === dropdownVal);
    if (defaultValue) {
      setSelectedDate(defaultValue);
      currentDateMatrix(defaultValue);
    }
  }, [setOptions, setSelectedDate, tab, currentDateMatrix]);

  useEffect(() => {
    if (userEmail && (activeStorechecker === true || selectedStoreId === '')) {
      getDefaultLocation({
        variables: { request: { email: userEmail, storeId: selectedStoreId } },
        context: {
          headers: {
            Authorization: localStorage.getItem('jwtToken'),
          },
        },
      });
    }
  }, [userEmail, getDefaultLocation, selectedStoreId, activeStorechecker]);

  const handleDateChange = (e) => {
    setSelectedDate(e);
    currentDateMatrix(e);
    localStorage.setItem('selectedDate', e.value);
  };

  const primarylocation = selectedLocation?.locationName || '';
  const statelocation = getLocationStateToken(primarylocation);
  const withoutstatelocation = getLocationNameWithoutState(primarylocation);

  return (
    <AppHeader
        headerContent={
          <Box sx={filterContainerStyles}>
            {locationLoading ? (
              <CircularProgress color="inherit" size={30} />
            ) : (
              <div className="locationRow">
                {toTitleCase(withoutstatelocation ?? withoutstatelocation)}
                {primarylocation === 'NA' || statelocation.length !== 2 ? (
                  ''
                ) : (
                  <span>, {statelocation}</span>
                )}
              </div>
            )}
            {options.length > 0 ? (
              <div className="blue-dropdown">
                <SelectDropdown
                  className="dateRow"
                  styles={customStyles}
                  onChange={handleDateChange}
                  options={options}
                  value={selectedDate}
                  isSearchable={false}
                />
              </div>
            ) : (
              <CircularProgress color="inherit" size={30} />
            )}
          </Box>
        }
      >
        {locationError.message ? (
          <ErrorMessage
            statusCode={locationError?.networkError?.statusCode}
            message={DATA_FETCH_ERROR}
          />
        ) : null}
        {activeStorechecker === false && selectedStoreId ? (
          <ErrorMessage message={ONLOAN_INVALID_STOREID_ERROR} />
        ) : null}
        <LaborTabManager />
        <BottomNavigator
          Label="Labor"
          LeftRoute="/omnichannel-details/bopis"
          // LeftRoute="/services-details/drivers"
          RightRoute="/inventory-details/drivers"
          DisableLeft={false}
          DisableRight={false}
        />
      </AppHeader>
  );
};

LaborDetails.propTypes = {
  employeeInfo: PropTypes.shape({ adUpn: PropTypes.string }),
  currentDateMatrix: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  employeeInfo: state.auth.employeeInfo,
});
const mapDispatchToProps = (dispatch) => ({
  currentDateMatrix: (selectedDateMatrix) =>
    dispatch(setCurrentDateMatrix(selectedDateMatrix)),
});
export default connect(mapStateToProps, mapDispatchToProps)(LaborDetails);
